import { AsyncPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, switchMap, take } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { ICreateTimeEntryRequest, ISearchTimeEntriesRequest, ITimeEntry, IUpdateTimeEntryRequest } from '../models/time-entry';
import { TimeEntryService } from '../services/time-entry.service';
import { currentEmployeeSelector, getCurrentEmployee } from 'src/app/stores/global/current-employee/current-employee.store';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { Store } from '@ngrx/store';
import { getEmployees } from 'src/app/stores/global/employees/employees.store';

@Injectable({
  providedIn: 'root'
})
export class TimeEntriesStorageService {

  constructor(
    private timeEntryService: TimeEntryService,
    private asyncPipe: AsyncPipe,
    private store: Store<AppStateInterface>
  ) {
    this.store.dispatch(getEmployees());
   }

  private _timeEntries$ = new BehaviorSubject<ITimeEntry[]>([]);
  public timeEntries$ = this._timeEntries$.asObservable();

  private _timeEntriesGrid$ = new BehaviorSubject<IGridResult<ITimeEntry[]>>(null);
  public timeEntriesGrid$ = this._timeEntriesGrid$.asObservable();

  listRequest : ISearchTimeEntriesRequest = {
    pageNumber: 0,
    pageSize: 25
  }

  listTimeEntrys(request: ISearchTimeEntriesRequest = this.listRequest){
    this.timeEntryService.searchTimeEntries(request).subscribe(response => {
      this._timeEntries$.next(response.data)
      this._timeEntriesGrid$.next({
        data: response.data,
        total: response.totalCount
      })
    })
  }

  listTimeEntriesOfCurrentUserToday(){
    var request: ISearchTimeEntriesRequest = {
      pageNumber: 1,
      pageSize: 999999,
      employeeId: null,
      dateFrom: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000),
      dateTo: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000),
      orderBy:['Date','Start']
    }    
    

    // Read the employee once per call. A lasting store subscription on this root service would
    // never be cleaned up and would re-run the search on every getCurrentEmployee.
    this.store.select(currentEmployeeSelector)
    .pipe(
      filter(employee => !!employee),
      take(1),
      switchMap(employee => this.timeEntryService.searchTimeEntries({ ...request, employeeId: employee.id }))
    )
    .subscribe(response => {
      this._timeEntries$.next(response.data)
      this._timeEntriesGrid$.next({
        data: response.data,
        total: response.totalCount
      })
    })
  }

  addTimeEntry(request: ICreateTimeEntryRequest){
    this.timeEntryService.createTimeEntry(request)
      .subscribe(response => {
        this.listTimeEntrys();
      })
  }

  updateTimeEntry(request: IUpdateTimeEntryRequest){
    this.timeEntryService.updateTimeEntry(request)
      .subscribe(response => {
        this.listTimeEntrys();
      })
  }

  deleteTimeEntry(id:string){
    this.timeEntryService.deleteTimeEntry(id)
      .subscribe(response => {
        this.listTimeEntrys();
      })
  }

}
